import {defineConfig, getUrl} from "../defineConfig";

export function createProdConfig(location: string) {
    return defineConfig({
        env: "production",
        apiOrigin: 'https://sports-bets.yuumi-soft.fr/',
        apiURL: getUrl('https://yuumi-backend.duckdns.org/', location)
    });
}
